module.exports = "/static/assets/2081fa78ed270568e998a3a568b38dc4.png";